export const FORM_INPUT_ON_CHANGE = 'FORM_INPUT_ON_CHANGE';
export const FORM_ON_ERRORS = 'FORM_ON_ERRORS';
export const FORM_CLEAR_ERRORS = 'FORM_CLEAR_ERRORS';
export const FORM_RESET_STATE = 'FORM_RESET_STATE';
export const FORM_PROCESSING = 'FORM_PROCESSING';
export const FORM_SET_GLOBAL_SETTINGS = 'FORM_SET_GLOBAL_SETTINGS';
export const FORM_SET_ERROR_ORIGIN = 'FORM_SET_ERROR_ORIGIN';

export const APP_SET_QUERY_STRING_TO_STATE = 'APP_SET_QUERY_STRING_TO_STATE';
export const APP_SET_TRANSLATOR = 'APP_SET_TRANSLATOR';
export const APP_SET_PAGE_ERROR = 'APP_SET_PAGE_ERROR';
export const APP_SET_GEO_INFORMATION = 'APP_SET_GEO_INFORMATION';
export const APP_SET_USER_DETAILS = 'APP_SET_USER_DETAILS';
export const APP_SET_SIGNED_OUT = 'APP_SET_SIGNED_OUT';
export const APP_SET_DYNAMIC_CONTENT = 'APP_SET_DYNAMIC_CONTENT';
export const APP_SET_DTL_PAGE_NAME = 'APP_SET_DTL_PAGE_NAME';
export const APP_SET_IS_CHROME_INCOGNITO = 'APP_SET_IS_CHROME_INCOGNITO';
export const APP_SET_CENTRAL_CONFIG = 'APP_SET_CENTRAL_CONFIG';

export const MIGRATE_SET_BRAND_SIGNIN_TOKEN = 'MIGRATE_SET_BRAND_SIGNIN_TOKEN';
export const MIGRATE_SET_SHOW_VERIFICATION_SENT = 'MIGRATE_SET_SHOW_VERIFICATION_SENT';
export const MIGRATE_SET_SHOW_CONGRATULATION = 'MIGRATE_SET_SHOW_CONGRATULATION';
export const MIGRATE_SET_STATUS_CODE = 'MIGRATE_SET_STATUS_CODE';

export const SET_ICON_SOURCE = 'SET_ICON_SOURCE';

// export const GET_AB_TEST_CONFIG = 'GET_AB_TEST_CONFIG';
// export const GET_AB_TEST_CONFIG_RECAPTHA='GET_AB_TEST_CONFIG_RECAPTHA';
// export const GET_AB_TEST_CONFIG_FULFILLED = 'GET_AB_TEST_CONFIG_FULFILLED';
// export const GET_AB_TEST_CONFIG_NEWSIGNUP_FULFILLED = 'GET_AB_TEST_CONFIG_NEWSIGNUP_FULFILLED';
// export const GET_AB_TEST_CONFIG_REJECTED = 'GET_AB_TEST_CONFIG_REJECTED';
export const SET_TEMPORARY_RESET_PASSWORD_DATA = 'SET_TEMPORARY_RESET_PASSWORD_DATA';
export const SAVE_PASSWORD_STRENGTH = 'SAVE_PASSWORD_STRENGTH';
export const SET_UPDATE_PASSWORD = 'SET_UPDATE_PASSWORD';

export const SET_SHOW_SESSION_EXPIRY_OVERLAY = 'SET_SHOW_SESSION_EXPIRY_OVERLAY';

export const SET_SOCIAL_ERROR = 'SET_SOCIAL_ERROR';
export const RESET_SOCIAL_ERROR = 'RESET_SOCIAL_ERROR';
export const SET_SOCIAL_LOGIN_IN_PROGRESS = 'SET_SOCIAL_LOGIN_IN_PROGRESS';
export const SET_EXPIREDLINK_POPUP = 'SET_EXPIREDLINK_POPUP';
export const SET_MIGRATEDLINK_POPUP = 'SET_MIGRATEDLINK_POPUP';
export const PASSWORD_RESET_REQUIRED = 'PASSWORD_RESET_REQUIRED';
export const CLOSE_PASSWORD_RESET_REQUIRED = 'CLOSE_PASSWORD_RESET_REQUIRED';
export const SHOW_RECAPTHA_IMAGE = 'SHOW_RECAPTHA_IMAGE';





